<div class="{{localService.selectedLanguageCode}}"  *ngIf="localService.languageContent && localService.languageContent.gallery">
  <div class="center" style="max-width:800px;">
    <div class="banner center" style="max-width:600px;">
      <div class="row row_header">
        <div class="col-3">
          {{localService.languageContent.common.action}}
        </div>
        <div class="col-9">
          {{localService.languageContent.table.title}}
          <div class="icon_action_header">
            <i class="material-icons on_language_changed" style="display:none;" (click)="onLoad()">replay_circle_filled</i>
            <app-file-upload (onFileUploaded)="onLoad()"></app-file-upload>
          </div>
        </div>
      </div>
      <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}" *ngIf="source">
        <div class="row styled_row" *ngFor="let item of source.items">
          <div class="col-3">
            <i class="material-icons button icon_adjust" title="{{item.v2 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}" (click)="onActiveInactiveStatus(item.key)" [ngStyle]="{'color': item.v2 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v2 == '1' ? "toggle_on" : "toggle_off"}}</i>
            <i class="material-icons icon_adjust" (click)="localService.copyContent(item.key)">content_copy</i>
            <i class="material-icons icon_adjust" (click)="localService.showImage(item.key)">image</i>
          </div>
          <div class="col-9">
            {{item.v1}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-paging *ngIf="source" [paging]="source.paging" (onPagingRefreshed)="onLoad()"></app-paging>
</div>
